const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//showEvent
import {showEvent} from "../include/module";
showEvent();

$(window).on('load' , function() {

  // setTimeout(function(){$('#st-Loader .st-Loader_Logo').addClass("load");},400);
  $('#st-Loader').addClass("hidden");
  setTimeout(function(){$('#st-Loader').remove();},800);

  setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},0);
  setTimeout(function(){ scrollCommonAnime(); },600);

});



// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  // //シーンを作成
  // const scene = new ScrollMagic.Scene({
  //     triggerElement: target,
  //     triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-News',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene4 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .95,
        duration: '0'
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};



// WEBPACK FOOTER //
// ./src/assets/js/common/script.js